import { Link } from 'react-router-dom';
import { categories } from '@/mocks/news';

export default function CategoryGrid() {
  const [first, ...rest] = categories;

  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.25em] text-secondary-600">TOPIC AREAS</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">按主题分类找话题</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            五个方向覆盖近期讨论的主要板块。想系统补课，从分类进入会比逐条刷榜更高效。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-12">
          <Link
            to={`/topics?cat=${first.id}`}
            className="group relative overflow-hidden rounded-lg lg:col-span-5"
          >
            <div className="h-64 w-full lg:h-full lg:min-h-[340px]">
              <img
                src={first.image}
                alt={`${first.name}分类配图`}
                title={`${first.name} - 看料大瓜话题分类`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-6">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
                {first.count} 个话题
              </span>
              <h3 className="mt-3 font-heading text-2xl font-bold text-background-50">{first.name}</h3>
              <p className="mt-2 max-w-md text-sm leading-relaxed text-background-200">{first.desc}</p>
            </div>
          </Link>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-7">
            {rest.map((cat) => (
              <Link
                key={cat.id}
                to={`/topics?cat=${cat.id}`}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="h-36 w-full overflow-hidden">
                  <img
                    src={cat.image}
                    alt={`${cat.name}分类配图`}
                    title={`${cat.name} - 看料大瓜话题分类`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                      {cat.name}
                    </h3>
                    <span className="text-xs text-foreground-500">{cat.count} 个</span>
                  </div>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}